module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"product_variant":"Product/variant"},"id":{"product_variant":"Produk/varian"}}')
  delete Component.options._Ctor
}
